import * as localforage from "localforage";
import axios from "axios";
import { currentDateInUTC } from "../helpers/datetimeHandlers";

export const getEventLogApi = async device_ids => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/command/get-event-log`,
    method: "POST",
    data: {
      execute_datetime: currentDateInUTC(),
      device_ids: device_ids,
      company_id,
      execute_type: "event_log"
    }
  });
  return res.data;
};

export const getEventLogsettingApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
    let res = await axios({
      url: `/api/v2/device/event-log-setting`,
      method: "GET",
      params: {
        device_id,
        company_id,
      },
    });
    return res.data;
};

export const setEventLogStatusApi = async (device_ids, is_disable) => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/command/event-log-set`,
    method: "POST",
    data: {
      device_ids,
      company_id,
      execute_type: "set_event_log_time",
      is_disable,
      execute_datetime: currentDateInUTC()
    }
  });
  return res.data;
};

export const getDatatableApi = async (device_id, type) => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/event-log-datatable`,
    method: "GET",
    params: {
      device_id,
      company_id,
      event_log_type: type
    }
  });
  return res.data;
};

export const getEventLogFileApi = async device_ids => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/command/get-event-log-file`,
    method: "POST",
    data: {
      device_ids: [device_ids],
      company_id,
      execute_type: "event_log_file",
      execute_datetime: currentDateInUTC()
    }
  });
  return res.data;
};

export const downloadEventLogFileApi = async device_id => {
  let res = await axios({
    url: `/api/v2/device/download-event-log-file`,
    method: "GET",
    params: {
      device_id
    }
  });
  return res.data;
};
